module.exports = __webpack_public_path__ + "didnt-redeem-white.svg?d78dbb0712bd997ea10968ef0c71f5bd";